import React from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import { useAppState } from '../../state';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f0f4f8',
    height: '100%',
  },
  container: {
    position: 'relative',
    flex: '1',
  },
  innerContainer: {
    display: 'flex',
    width: '888px',
    height: '379px',
    borderRadius: '12px',
    boxShadow: '0px 8px 24px 0px rgba(10, 102, 194, 0.15)',
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: 'auto',
      width: 'calc(100% - 40px)',
      margin: 'auto',
      maxWidth: '400px',
    },
  },
  swooshContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #0A66C2 0%, #084fa0 100%)',
    width: '296px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '120px',
    },
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '0 24px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      gap: '12px',
      width: '90%',
      textAlign: 'initial',
    },
  },
  logo: {
    width: '160px',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '80px',
    },
   background: 'white',
   borderRadius: '12px',

  },
  tagline: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: '0.85rem',
    fontWeight: 500,
    letterSpacing: '0.3px',
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      margin: 0,
    },
  },
  content: {
    background: 'white',
    width: '100%',
    padding: '3em 4em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '2em',
    },
  },
}));

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const classes = useStyles();
  const { user } = useAppState();
  const location = useLocation();

  return (
    <div className={classes.background}>
      {user && location.pathname !== '/login' && <UserMenu />}
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.swooshContainer}>
            <div className={classes.logoContainer}>
              <img src="/app-logo.png" alt="Jobexcello" className={classes.logo} />
              <Typography variant="body2" className={classes.tagline}>
                AI-Powered Video Interviews,<br />Smarter Hiring Decisions
              </Typography>
            </div>
          </div>
          <div className={classes.content}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default IntroContainer;